<script setup lang="ts">
  defineOptions({
    name: 'ChatTabs',
  })

  import { computed, type PropType } from 'vue'

  import { useI18n } from 'vue-i18n'

  import CPButton from '@ui/components/CPButton.vue'

  import CPText from '@ui/components/CPText.vue'

  import type { ChatTab, ChatTabValue } from '@communities/chats-layer/types/chat-tabs.types'

  const props = defineProps({
    modelValue: {
      type: String as PropType<ChatTabValue>,
      default: 'all',
    },
    tabs: {
      type: Array as PropType<ChatTab[]>,
      default: undefined,
    },
    unreadCount: {
      type: Number,
      default: 0,
    },
  })

  const emit = defineEmits<{
    'update:modelValue': [value: ChatTabValue]
  }>()

  const { t } = useI18n()

  const defaultTabs = computed<ChatTab[]>(() => [
    { label: t('chats.tabs.all'), value: 'all' },
    { label: t('chats.tabs.unread'), value: 'unread', count: props.unreadCount },
  ])

  const activeTabs = computed(() => props.tabs || defaultTabs.value)

  const isSelected = (tab: ChatTab) => props.modelValue === tab.value

  const handleTabClick = (tab: ChatTab) => {
    emit('update:modelValue', tab.value)
  }
</script>

<template>
  <div class="flex gap-2 px-4 py-3">
    <CPButton
      v-for="tab in activeTabs"
      :id="`chat-tab-${tab.value}`"
      :key="tab.value"
      :type="isSelected(tab) ? 'primary' : 'secondary'"
      size="sm"
      class="!rounded-full"
      @click="handleTabClick(tab)"
    >
      <CPText
        size="sm"
        weight="medium"
        :class="{
          '!text-on-primary': isSelected(tab),
          '!text-body': !isSelected(tab),
        }"
      >
        {{ tab.label }}
        <span v-if="tab.count && tab.count > 0" class="ml-1">
          {{ tab.count }}
        </span>
      </CPText>
    </CPButton>
  </div>
</template>
